import React from 'react';
import { observer } from 'mobx-react-lite';
import { IMInputText, IMSelect } from '@insurancemenu/imenu-components-lib';
import { IMNaicsSearch } from '@insurancemenu/imenu-components-lib/dist/components/imForm/capabilities/naics/IMNaicsSearch';
import SectionTitle from 'components/common/general/SectionTitle';
import DomainProductLines from 'components/common/initiate-proposal/DomainProductLines';
import {
  IMFormStyled,
  FollowingSectionTitleStyled,
  IMZipCodeFieldStyled,
  IMZipCountyFieldStyled,
  IMZipStateFieldStyled,
  FormFieldWrapperStyled,
} from 'components/common/initiate-proposal/styles';
import { useDDWAQuoteProposalInfoPageStore } from 'store/pages/quote/quote-proposal-info/ddwa/pageStore';
import { DDWA_PROPOSAL_INFO_FORM_ID } from './constants';

const DDWAQuoteProposalInfoForm: React.FC = observer(() => {
  const {
    proposalFormDelegate: { proposalForm, effectiveDatesOptions },
    proposalInfoDelegate: { domainProductLineItems, isDomainProductLinesLoading },
    isStepCompleted,
  } = useDDWAQuoteProposalInfoPageStore();

  return (
    <IMFormStyled id={DDWA_PROPOSAL_INFO_FORM_ID} formController={proposalForm}>
      <SectionTitle title="Basic Information" />
      <IMInputText label="Proposal Name" name="proposalName" size="full" />
      <IMSelect label="Effective Date" name="effectiveDate" size="full" options={effectiveDatesOptions} disabled />
      <IMZipCodeFieldStyled size="s" disabled={isStepCompleted} />
      <IMZipStateFieldStyled size="s" disabled />
      <IMZipCountyFieldStyled size="s" disabled={isStepCompleted} />

      <FollowingSectionTitleStyled title="Additional Information" />
      <FormFieldWrapperStyled>
        <IMNaicsSearch label="NAICS Code" size="full" disabled />
      </FormFieldWrapperStyled>

      <FollowingSectionTitleStyled title="Available Product Lines" />
      <DomainProductLines domainProductLineItems={domainProductLineItems} isLoading={isDomainProductLinesLoading} />
    </IMFormStyled>
  );
});

export default DDWAQuoteProposalInfoForm;
